import { createFileRoute } from '@tanstack/react-router';

import { UpdateBusinessDetails } from 'features/get-started/UpdateBusinessDetails';

export const Route = createFileRoute('/_authenticated/get-started/_get-started/update-business-details/')({
  component: UpdateBusinessDetailsRoute
});

function UpdateBusinessDetailsRoute() {
  return <UpdateBusinessDetails />;
}
